import bankProfile from "@/api/finance/bank-profile";
import bankAccount from "@/api/finance/bank-account";
import { baseState, baseMutations } from "@/store/mixins";
import { isEmpty } from "lodash";

export const state = {
    ...baseState
};

export const getters = {};

export const mutations = {
    ...baseMutations
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.currentPage,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return bankProfile.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    store(context, data) {
        return bankProfile.store(data);
    },

    async find(context, id) {
        if (isEmpty(context.state.edit_data)) {
            let response = await bankProfile.find(id);
            context.commit("SET_EDIT_DATA", response.data);
        }
    },

    update(context, { id, data }) {
        return bankProfile.update(id, data);
    },

    destroy(context, id) {
        return bankProfile.destroy(id);
    },

    qrUpload(context, data) {
        return bankAccount.qrUpload(data);
    },

    storeAccount(context, { bankId, data }) {
        return bankAccount.store(bankId, data);
    },

    destroyAccount(context, accountId) {
        return bankAccount.destroy(accountId);
    },

    searchEmployees(context, search) {
        return bankProfile.employees({ params: { search } }).then(res => res.data);
    }
};
